import i18n from '@/i18n/index'
import constant from '@/utils/constant.js'

export default {
  formData: [{
    title: i18n.t('form.store.generalInformation'),
    name: 0,
    createDateItem: [{
      span: 8,
      prop: 'supplier_id',
      name: 'select',
      options: [],
      label: i18n.t('form.purchase.supplier'),
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        key: 'id',
        value: 'id',
        filterable: true,
        maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON,
        nextChange: true,
        nextChangeProp: 'supplier_id',
        rules: [
          { required: true, message: i18n.t('text.require', { name: i18n.t('form.purchase.itemStock') }) }
        ]
      }
    }, {
      span: 8,
      prop: 'delivery_date',
      name: 'date',
      label: i18n.t('form.purchase.deliveryDate'),
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
      }
    }, {
      span: 16,
      prop: 'remarks',
      name: 'input',
      type: 'textarea',
      label: i18n.t('form.purchase.remark'),
      placeholder: i18n.t('placeholder.defaultInput'),
      Object: {
        maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
      }
    }]
  }
  // , {
  //   title: i18n.t('form.purchase.itemList'),
  //   name: 1,
  //   createDateItem: [{
  //     span: 24,
  //     prop: 'purchase_order_items_attributes',
  //     name: 'array',
  //     value: [],
  //     label: '',
  //     Object: {
  //       delete: '_destroy',
  //       'array-label-width': '80px'
  //     },
  //     createDateFirstItem: [{
  //       span: 8,
  //       prop: 'shop_item_id',
  //       name: 'select',
  //       options: [],
  //       value: [],
  //       label: i18n.t('form.purchase.item'),
  //       placeholder: i18n.t('placeholder.defaultSelect'),
  //       Object: {
  //         key: 'id',
  //         value: 'id',
  //         loading: false,
  //         nextChange: true,
  //         nextChangeProp: 'shop_item_id',
  //         filterable: true,
  //         maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
  //       }
  //     }, {
  //       span: 8,
  //       prop: 'shop_item_stock_id',
  //       name: 'select',
  //       options: [],
  //       value: [],
  //       label: i18n.t('form.purchase.itemStock'),
  //       placeholder: i18n.t('placeholder.defaultSelect'),
  //       Object: {
  //         key: 'id',
  //         loading: false,
  //         filterable: true,
  //         maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
  //       }
  //     }, {
  //       span: 8,
  //       prop: 'quantity',
  //       name: 'input',
  //       type: 'number',
  //       label: i18n.t('form.purchase.quantity'),
  //       placeholder: i18n.t('placeholder.defaultInput'),
  //       Object: {
  //         rules: [
  //           { required: true, message: i18n.t('text.require', { name: i18n.t('form.purchase.quantity') }) }
  //         ],
  //         maxlength: constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON
  //       }
  //     }]
  //   }]
  // }
  ]
}
